
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "ActionInterface": [
      "BaseActionNode",
      "BookingPetActionNode",
      "GenericCarePlanActionNode",
      "IIPPurchasePetActionNode",
      "InPersonVisitActionNode",
      "PetActionNode",
      "PrescriptionPetActionNode",
      "PrescriptionsPetActionNode",
      "RXVirtualVisitActionNode",
      "RecommendationCarePlanActionNode",
      "RelatedResourceCarePlanActionNode",
      "ScheduleAppointmentCarePlanActionNode",
      "ViewCarePlanPetActionNode",
      "VirtualVisitActionNode"
    ],
    "ActionNode": [
      "BaseActionNode",
      "BookingPetActionNode",
      "GenericCarePlanActionNode",
      "IIPPurchasePetActionNode",
      "InPersonVisitActionNode",
      "PetActionNode",
      "PrescriptionPetActionNode",
      "PrescriptionsPetActionNode",
      "RXVirtualVisitActionNode",
      "ScheduleAppointmentCarePlanActionNode",
      "ViewCarePlanPetActionNode",
      "VirtualVisitActionNode"
    ],
    "AddOnInterface": [
      "EmergencyFundAddOnNode",
      "VCPRAddOnNode"
    ],
    "AddOnNode": [
      "EmergencyFundAddOnNode",
      "VCPRAddOnNode"
    ],
    "AddOnStatusInterface": [
      "EmergencyFundStatusNode",
      "VCPRStatusNode"
    ],
    "AddOnStatusNode": [
      "EmergencyFundStatusNode",
      "VCPRStatusNode"
    ],
    "BookingInterface": [
      "RXBookingNode"
    ],
    "CarePlanActionInterface": [
      "GenericCarePlanActionNode",
      "InPersonVisitActionNode",
      "RXVirtualVisitActionNode",
      "RecommendationCarePlanActionNode",
      "RelatedResourceCarePlanActionNode",
      "ScheduleAppointmentCarePlanActionNode",
      "VirtualVisitActionNode"
    ],
    "CarePlanActionNode": [
      "GenericCarePlanActionNode",
      "InPersonVisitActionNode",
      "RXVirtualVisitActionNode",
      "RecommendationCarePlanActionNode",
      "RelatedResourceCarePlanActionNode",
      "ScheduleAppointmentCarePlanActionNode",
      "VirtualVisitActionNode"
    ],
    "CheckoutLineItem": [
      "EmergencyProtectionQuoteLine",
      "MembershipQuoteLine",
      "PrescriptionQuoteLine"
    ],
    "ChoiceUnion": [
      "ChoiceAlgoliaNode",
      "ChoiceStaticOptionsNode",
      "ImageStaticOptionsNode"
    ],
    "ConsumableFeatureInterface": [
      "PrescriptionFeature"
    ],
    "ConsumableQuoteLineInterface": [
      "PrescriptionQuoteLine"
    ],
    "ConversationActionInterface": [
      "InPersonVisitActionNode",
      "PrescriptionsPetActionNode",
      "RXVirtualVisitActionNode",
      "ViewCarePlanPetActionNode",
      "VirtualVisitActionNode"
    ],
    "CoreProductDetailsNode": [
      "CoreMedicationNode"
    ],
    "DiscountSource": [
      "CouponNode",
      "DefaultPartnerDiscount",
      "PromoCodeNode"
    ],
    "EmergencyProtectionFeatures": [
      "EmergencyProtection",
      "EmergencyProtectionQuoteLine"
    ],
    "FundingSource": [
      "FullPerksContractNode",
      "SubscriptionNode"
    ],
    "InsurancePolicyInterface": [
      "EmergencyFundPolicyNode",
      "PetInsurancePolicyNode"
    ],
    "InsurancePolicyNode": [
      "EmergencyFundPolicyNode",
      "PetInsurancePolicyNode"
    ],
    "KeyAction": [
      "BookRxVisit",
      "BuyProduct",
      "ExploreFinancialProtection",
      "ReadArticle",
      "ReviewCareAction",
      "ReviewProgram",
      "StartLiveVisit",
      "ViewIIPQuote"
    ],
    "MembershipFeatures": [
      "Membership",
      "MembershipQuoteLine"
    ],
    "NextResponse": [
      "QuestionGroupResponse",
      "RedirectResponse"
    ],
    "Node": [
      "AdministrationRouteNode",
      "AllergyNode",
      "ArticleRecommendationNode",
      "AutoshipPlanNode",
      "BaseActionNode",
      "BillingPlanNode",
      "BookingPetActionNode",
      "BookingWaitlistNode",
      "BooleanPetDetailNode",
      "BreedFamilyNode",
      "CardPaymentMethod",
      "CarePlanActionComplianceStatusRecordNode",
      "CarePlanActionFeedbackNode",
      "CarePlanNode",
      "CartNode",
      "CartNodeV2",
      "ChoicePetDetailNode",
      "ClaimAttachmentNode",
      "ClaimRequestNode",
      "ClientUploadNode",
      "ClinicLocationNode",
      "CollectionNode",
      "ConditionDrugInteractionNode",
      "ConditionGroupNode",
      "ConditionNode",
      "ConsentTypeNode",
      "ConsumableFeaturePrice",
      "ConsumableFeatureTier",
      "CoreClinicNode",
      "CoreIngredientLineNode",
      "CoreIngredientNode",
      "CoreMedicationNode",
      "CorePrescriptionNode",
      "CouponNode",
      "DatePetDetailNode",
      "DeviceNode",
      "DiagnosticAnswerNode",
      "DiagnosticQuestionNode",
      "DiagnosticQuestionTargetValuesNode",
      "DrugInteractionNode",
      "EmergencyFundAddOnNode",
      "EmergencyFundPolicyNode",
      "EmergencyFundStatusNode",
      "EmergencyProtectionConfig",
      "ExternalLinkRecommendationNode",
      "ExternalPaymentMethodNode",
      "FeatureBundle",
      "FileNode",
      "FlatPetDetailNode",
      "FormResponseNode",
      "FormResponseType",
      "FulfillmentNode",
      "FullPerksContractNode",
      "GenericCarePlanActionNode",
      "GenericFileNode",
      "IIPOfferNode",
      "IIPPurchasePetActionNode",
      "ImagePetDetailNode",
      "InPersonVisitActionNode",
      "InPersonVisitResultNode",
      "InsightCategoryNode",
      "InsightNode",
      "InsurancePolicyDocumentNode",
      "InvoiceNode",
      "MedicalRecordNode",
      "MedicationCategoryNode",
      "MedicationDosageNode",
      "MedicationNode",
      "MembershipTierConfig",
      "ModelPetDetailNode",
      "OrderInvoiceNode",
      "OrderLineNode",
      "OrderNode",
      "OrderV2Node",
      "PartnerNode",
      "PartnerReferralOfferNode",
      "PartnerReferralOfferProductNode",
      "PayPalPaymentMethod",
      "PaymentNode",
      "PeriodicCheckInNode",
      "PetActionNode",
      "PetDetailNode",
      "PetInsightNode",
      "PetInsurancePolicyNode",
      "PetSymptomCheckerResultType",
      "PlanSubscriptionPrice",
      "PrescriptionConsumable",
      "PrescriptionNode",
      "PrescriptionPetActionNode",
      "PrescriptionRequestNode",
      "PrescriptionsPetActionNode",
      "PriceNode",
      "ProductCategoryNode",
      "ProductComponentCategoryNode",
      "ProductComponentNode",
      "ProductFamilyNode",
      "ProductFamilySuggestionNode",
      "ProductManufacturerNode",
      "ProductNode",
      "ProductRecommendationNodeV2",
      "ProductVariantNode",
      "ProductVariantSubscriptionPriceNode",
      "ProfessionalNode",
      "PromoCodeNode",
      "RXBookingNode",
      "RXVirtualVisitActionNode",
      "RecommendationCarePlanActionNode",
      "Refund",
      "RelatedResourceCarePlanActionNode",
      "ScheduleAppointmentCarePlanActionNode",
      "SubscribableConsumable",
      "SubscriptionLineNode",
      "SubscriptionNode",
      "SupplierNode",
      "SymptomCheckerResponseType",
      "SymptomNode",
      "TextPetDetailNode",
      "UserConsentNode",
      "UserPartnerNode",
      "UserPlanFundingSourceNode",
      "UserPlanNode",
      "UserPlanStatusRecordNode",
      "UserSatisfactionSurveyNode",
      "VCPRAddOnNode",
      "VCPRStatusNode",
      "ViewCarePlanPetActionNode",
      "VirtualVisitActionNode"
    ],
    "PaymentMethodInterface": [
      "CardPaymentMethod",
      "PayPalPaymentMethod"
    ],
    "PaymentMethodNode": [
      "CardPaymentMethod",
      "PayPalPaymentMethod"
    ],
    "PetDetailInterface": [
      "BooleanPetDetailNode",
      "ChoicePetDetailNode",
      "DatePetDetailNode",
      "FlatPetDetailNode",
      "ImagePetDetailNode",
      "ModelPetDetailNode",
      "TextPetDetailNode"
    ],
    "PetDetailNodeV2": [
      "BooleanPetDetailNode",
      "ChoicePetDetailNode",
      "DatePetDetailNode",
      "FlatPetDetailNode",
      "ImagePetDetailNode",
      "ModelPetDetailNode",
      "TextPetDetailNode"
    ],
    "PetTodoInterface": [
      "BookingPetActionNode",
      "IIPPurchasePetActionNode",
      "InPersonVisitActionNode",
      "PetActionNode",
      "PrescriptionPetActionNode",
      "PrescriptionsPetActionNode",
      "RXVirtualVisitActionNode",
      "ViewCarePlanPetActionNode",
      "VirtualVisitActionNode"
    ],
    "PrescriptionFeatures": [
      "PrescriptionFeature",
      "PrescriptionQuoteLine"
    ],
    "PrescriptionRequestResult": [],
    "PurchasedConsumableInterface": [
      "PrescriptionConsumable"
    ],
    "PurchasedTierInterface": [
      "EmergencyProtection",
      "Membership",
      "PrescriptionConsumable",
      "PrescriptionFeature"
    ],
    "QuoteLineInterface": [
      "EmergencyProtectionQuoteLine",
      "MembershipQuoteLine",
      "PrescriptionQuoteLine"
    ],
    "RangeValidatorNode": [
      "RangeCountValidatorNode",
      "RangeDateValidatorNode",
      "RangeDatetimeValidatorNode",
      "RangeDecimalValidatorNode",
      "RangeIntegerValidatorNode"
    ],
    "RecommendationNode": [
      "ArticleRecommendationNode",
      "ExternalLinkRecommendationNode",
      "ProductRecommendationNodeV2"
    ],
    "RenewalQuoteLineInterface": [
      "EmergencyProtectionQuoteLine",
      "MembershipQuoteLine",
      "PrescriptionQuoteLine"
    ],
    "SubscribableFeatureInterface": [
      "EmergencyProtectionConfig",
      "MembershipTierConfig",
      "SubscribableConsumable"
    ],
    "SubscribableQuoteLineInterface": [
      "EmergencyProtectionQuoteLine",
      "MembershipQuoteLine"
    ],
    "SubscribedFeatureInterface": [
      "EmergencyProtection",
      "Membership",
      "PrescriptionFeature"
    ],
    "ValidatorNode": [
      "RangeCountValidatorNode",
      "RangeDateValidatorNode",
      "RangeDatetimeValidatorNode",
      "RangeDecimalValidatorNode",
      "RangeIntegerValidatorNode"
    ],
    "VisitInterface": [
      "ConversationType",
      "GenericCarePlanActionNode",
      "InPersonVisitActionNode",
      "PeriodicCheckInNode",
      "RXBookingNode",
      "RXVirtualVisitActionNode",
      "VirtualVisitActionNode"
    ]
  }
};
      export default result;
    